export default "__VITE_PUBLIC_ASSET__11f0bff2__"